import { render, staticRenderFns } from "./OptionInput.vue?vue&type=template&id=3c6b6d32&scoped=true&"
import script from "./OptionInput.vue?vue&type=script&lang=js&"
export * from "./OptionInput.vue?vue&type=script&lang=js&"
import style0 from "./OptionInput.vue?vue&type=style&index=0&id=3c6b6d32&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3c6b6d32",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VFileInput } from 'vuetify/lib/components/VFileInput';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VMain } from 'vuetify/lib/components/VMain';
import { VRow } from 'vuetify/lib/components/VGrid';
import { VTextField } from 'vuetify/lib/components/VTextField';
installComponents(component, {VBtn,VFileInput,VIcon,VMain,VRow,VTextField})
